/**
* Submittal Category JS
* -----------------------------------------------------------------------------
*
* All the JS for the Submittal Category component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'submittal-category',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( document ).on( 'click', '.submittal-category__button', function( e ) {
        e.preventDefault();

        const termId = $( this ).data( 'term_id' );
        let doingAjax = false;

        if ( $( '#submittal-category-target-' + termId ).is( ':empty' ) ) {
          $.ajax( {
            type: 'POST',
            url: siteInfo.wpApiSettings.ll + 'submittals/next',
            data: {
              term_id: termId,
            },
            beforeSend: function( xhr ) {
              $( '#submittal-category-target-' + termId ).parent( '.submittal-category' ).addClass( 'is-open' );
              xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
              $( '.submittals-loading' ).addClass( 'doing-ajax' );
            },
            success: function( data ) {
              $( '#submittal-category-target-' + termId ).html( data.html );
            },
            complete: function( jqXHR, status ) {
              $( '#submittal-category-target-' + termId ).slideDown();
              doingAjax = false;
              $( '.submittals-loading' ).removeClass( 'doing-ajax' );
            },
          } );
        } else {
          if ( !$( '#submittal-category-target-' + termId ).is( ':hidden' ) ) {
            $( '#submittal-category-target-' + termId ).parent( '.submittal-category' ).removeClass( 'is-open' );
          } else {
            $( '#submittal-category-target-' + termId ).parent( '.submittal-category' ).addClass( 'is-open' );
          }
          $( '#submittal-category-target-' + termId ).slideToggle();
        }
      } );

      $( document ).on( 'submit', '#submittal-categories', function( e ) {
        $( '.submittals-loading' ).addClass( 'doing-ajax' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'submittal-category', COMPONENT );
} )( app );
